"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityRelationType = void 0;
var ActivityRelationType;
(function (ActivityRelationType) {
    ActivityRelationType[ActivityRelationType["Location"] = 0] = "Location";
})(ActivityRelationType = exports.ActivityRelationType || (exports.ActivityRelationType = {}));
//# sourceMappingURL=ActivityRelationType.js.map